import { Controller } from "@hotwired/stimulus"

// Mounts the embedded React editor (window.FasuaEditor) in read-only review
// mode for the tutor submission show page. Reads the worksheet schema and
// review results map from a sibling JSON script tag identified by the
// stateId value.
//
// Usage:
//   <div data-controller="fasua-review-mount"
//        data-fasua-review-mount-state-id-value="fasua-review-state">
//     <div data-fasua-review-mount-target="root"></div>
//   </div>
export default class extends Controller {
  static targets = ["root"]
  static values = { stateId: { type: String, default: "fasua-review-state" } }

  connect() {
    const root = this.hasRootTarget ? this.rootTarget : this.element
    const stateEl = document.getElementById(this.stateIdValue)
    if (!stateEl || !window.FasuaEditor || typeof window.FasuaEditor.mount !== "function") return
    const state = JSON.parse(stateEl.textContent)
    this.handle = window.FasuaEditor.mount(root, {
      initialWorksheet: state.worksheet,
      mode: "review",
      reviewResults: state.reviewResults,
    })
  }

  disconnect() {
    this.handle?.unmount?.()
  }
}
